app.controller('CIF2-CTRL', ['$scope', '$window', '$q', '$filter', '$http', '$timeout',  '$uibModal', 'appFactory',
    function ($scope, $window, $q, $filter, $http, $timeout, $uibModal, appFactory) {

        $scope.bankRDN = '';
        $scope.CIFInvestor = {}
        $scope.bankpribadi = '';

        $scope.disableBank = true;
        $scope.disableCIFInvestorQuestionRDN = false;

        $scope.ListBank = {};

        $scope.prepareData = function () {

            if ($scope.CIFInvestor.IncomeExtraPerAnnum == '') {
                $scope.CIFInvestor.IncomeExtraPerAnnum == 0;
            }


            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

               
            } else if ($scope.CIFInvestor.QuestionRDN == '2') {
               
            } else {


            }
        };

        $scope.showAgreement = function (number) {

            let htmlName = 'template/BCAagereement' + number + '.html';
            var modalInstance = $uibModal
            .open({
                animation: true,
                templateUrl: htmlName,
                controller: 'BCAAgreementCtrl',
                size: 'lg',
                backdrop: 'static',
                resolve: {

                    agreementNumber: function () {

                        return number;
                    }
                }
            });

            modalInstance.result.then(function (response, agree) {

                if (response == 'accept') {

                    if (number == 1) {

                        $scope.agree1 = true;
                        $scope.disclaimerRDNBCA = true;
                    }

                    if (number == 2) {

                        $scope.agree2 = true;
                        $scope.disclaimerTAPRESBCA = true;
                    }

                    if (number == 3) {

                        $scope.agree3 = true;
                        $scope.disclaimerDEKLARASI = true;
                    }

                    if ($scope.disclaimerRDNBCA == true && $scope.disclaimerTAPRESBCA == true && $scope.disclaimerDEKLARASI == true)
                        $scope.disclaimerBank = true;
                }
            }, function () { });
        };

        $scope.validateAgreementRDNBCA = function () {

            if ($scope.CIFInvestor.QuestionRDN == 1) {

                if (!$scope.agree1) {

                    $scope.disclaimerRDNBCA = false;
                    $scope.showAgreement(1);
                }
            }
        }

        $scope.validateAgreementTAPRESBCA = function () {

            if ($scope.CIFInvestor.QuestionRDN == 1) {

                if (!$scope.agree2) {

                    $scope.disclaimerTAPRESBCA = false;
                    $scope.showAgreement(2);
                }
            }
        }

        $scope.validationinput = function () {

            var errorForm = $scope.myForm.$error.required
            var validation = $scope.myForm.$valid;
            var message = [];
            //console.log('error :', errorForm);

            if (errorForm) {
                for (let i = 0; i < errorForm.length; i++) {
                    //message += errorForm[i].$name + " , ";
                    message.push(errorForm[i].$name);
                }
            }

            //console.log($scope.CIFInvestor.BankStatus);

            //PROSES VALIDATION
            if (validation == false) {
                console.log("error : " + message);

                var SWALtranslate = $scope.SWALtranslate('validationinput');
                Swal.fire({
                    title: SWALtranslate.title,
                    text: SWALtranslate.message,
                    imageUrl: 'img/collection/wrong.png',
                    imageAlt: 'Preparation',
                    imageHeight: 250,
                    animation: false
                });
            }

        }


        var allPromise = $q.all([
             appFactory.getData(`/service/client.svc/GetCIFBank`).then(function (data) {

                 if (data.status == 200)
                     $scope.ListBank = data.data.d;
             }),
        ]);

        allPromise.then(function () {

            $http({
                method: 'GET',
                url: '/service/client.svc/getCIF',
                cache: true,
            }).then(function (data) {
                    if (data.data.d != null) {
                        var obj = data.data.d;
                        $scope.CIFInvestor = data.data.d;
                        $scope.CIFInvestor.Stage = 2;
                        if ($scope.CIFInvestor.QuestionRDN == 0) {

                            $scope.CIFInvestor.QuestionRDN = '';
                        }


                        //if ($scope.CIFInvestor.QuestionRDN == 3)
                        //    $scope.bankpribadi = "KB BANK";
                        //else
                        //    $scope.bankpribadi = $scope.CIFInvestor.BankName;

                        $scope.bankpribadi = $scope.CIFInvestor.BankName;
                        //if($scope.bankpribadi == 'KB BANK'){
                        //    $scope.CIFInvestor.BankStatus = 1
                        //    $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.FirstName;
                        //}
                        //else {
                        //    $scope.CIFInvestor.BankStatus = 2
                        //}

                    } // END IF data.data.d
            }, function (error) { });
        });
  
        $scope.submit = function () {
            console.log('submit');

            $scope.prepareData();

            //if ($scope.CIFInvestor.QuestionRDN == 3 && $scope.CIFInvestor.BankStatus == 1)
            //    $scope.bankpribadi = "KB BANK";

            var urlsvc = '/service/client.svc/SaveCIF'; // 1
            var preconfirmtranslate = "submitCif2"; // 2
            var postData = { cifdata: $scope.CIFInvestor } // 3
            var method = "POST"; // 4
            var SWALtranslate = $scope.SWALtranslate(preconfirmtranslate);
            $scope.CIFInvestor.BankName = $scope.bankpribadi;

            Swal.fire({
                title: SWALtranslate.title,
                html: `
                    <div id="status-text">
                    <ul style="text-align: left !important;">
                        <li>Nama Bank Pribadi: `+$scope.bankpribadi+` </li>
                        <li>Nomor Rekening Pribadi: `+$scope.CIFInvestor.BankNumber+`</li>
                        <li>Nama Pemilik Rekening: `+$scope.CIFInvestor.BankOwner+` </li>
                    </ul>
                    </br>
                        `+SWALtranslate.message+`
                     </div>
                    `,
                text: SWALtranslate.message,
                showCancelButton: false,
                confirmButtonColor: '#FFBC00',
                confirmButtonText: 'Submit <i class="fa fa-arrow-right ml-1" aria-hidden="true"></i>',
                customClass: {
                    confirmButton: 'swal-confirm-button-class',
                },
                showLoaderOnConfirm: true,
                preConfirm: (preConf) => {
                    const statusText = document.getElementById('status-text');
                    if (statusText) {
                        statusText.innerText = 'Your eKYC process is currently in progress. Please wait for a moment while we verify your information' ;
                    }
                    return $http({
                        method: method,
                        url: urlsvc,
                        data: postData 
                    }).then(data => {

                        console.log(data.data.d.result)

                        if (data.data.d.result) {

                            var SWALtranslate = $scope.SWALtranslate(data.data.d.message);

                            Swal.fire({
                                title: SWALtranslate.title,
                                text: SWALtranslate.message,
                                icon: "success",
                                showConfirmButton: false,
                                timer: 3000,
                            })

                            $window.location.href = "#/cif/data-pendukung";
                        } else {
                            var msg = "";

                            if (!data.data.d.response) {
                                msg = $scope.SWALtranslate(data.data.d.message);
                                msg = msg.message
                            }
                            else
                            {
                                msg = data.data.d.response;
                            }

                            Swal.fire({
                                title: 'Warning',
                                html: msg,
                                icon: "error",
                                showConfirmButton: true,
                                customClass: {
                                    confirmButton: 'swal-confirm-button-class',
                                },
                            })
                            return false;
                        }
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            "There is a problem connecting to the server. \
                            Please ensure your internet connection is active. If the problem persists, please try again later."
                        )
                        console.log(`Request failed: ${error}`)
                    })
                }
            })
        }
    }]);